// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__F94CbEkH","warning":"SignUpIncorrectBirthStep_warning__eCpAZMTa","back":"SignUpIncorrectBirthStep_back__zSiVzKBt"};